import useProperties from "hooks/useProperties";
import React from "react";
import { isObjectEmpty } from "utils/commonUtils";
import LocationIntelligence from "./LocationIntelligence";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { ReactComponent as InfoIcon } from "assets/icons/info_2.svg";
import useSubscription from "hooks/useSubscription";
import useAuth from "hooks/useAuth";

const LocationIntelligenceComponent = () => {
  const { propertyDetails } = useProperties();
  const { user } = useAuth();
  const { subscriptionStatus } = useSubscription();
  const isPremium = subscriptionStatus.hasPremium;

  return (
    <div>
      <div className="flex items-center justify-between">
        <h1 className="text-[16px] sm:text-[22px] font-bold text-black leading-[150%] ">
          Location Intelligence
        </h1>

        <span
          className="cursor-pointer"
          data-tooltip-id="location_intelligence_tooltip"
          data-tooltip-content="Utilizza l’intelligenza artificiale per ottenere info sui servizi disponibili nelle vicinanze, e capire la logistica urbana degli spostamenti"
        >
          <InfoIcon />
        </span>
        {/* Info Tooltip  */}
        <ReactTooltip
          id="location_intelligence_tooltip"
          place="top"
          positionStrategy="fixed"
          className="!max-w-64 !z-10 !text-sm !text-gray-500 !bg-white border !border-gray-200 !rounded-lg !shadow-xs"
        />
      </div>

      {!isObjectEmpty(propertyDetails) && (
        <LocationIntelligence property={propertyDetails} />
      )}
    </div>
  );
};

export default LocationIntelligenceComponent;
